import { FC } from 'react';
import { CbEmptySearchState } from 'ui/components/CbEmptySearchState';
import { useIsEmbedded } from 'providers';
import { GameFilters } from '../../types';
export interface GamesEmptyStateProps {
  activeFilter?: string;
  isMobile?: boolean;
  managerView?: boolean;
}
export const GamesEmptyState: FC<GamesEmptyStateProps> = ({
  activeFilter,
  isMobile,
  managerView = false
}) => {
  const {
    isEmbedded: isEmbeddedMode
  } = useIsEmbedded();
  const subject = managerView ? 'Your managed learners' : 'You';
  const getAlertByFilter = (): string => {
    switch (activeFilter) {
      case GameFilters.Active:
        return `${subject} have no active games at the moment.`;
      case GameFilters.Completed:
        return `${subject} have not completed any games yet.`;
      case GameFilters.Upcoming:
        return `${subject} have no upcoming games at the moment.`;
      case GameFilters.NeedsVerification:
        return `${subject} have no games needing verification at the moment.`;
      default:
        return `${subject} have no games at the moment.`;
    }
  };
  const getSuggestionByFilter = (): string => {
    switch (activeFilter) {
      case GameFilters.Completed:
        return 'Or a game is currently in review.';
      default:
        return '';
    }
  };
  return <CbEmptySearchState alert={getAlertByFilter()} suggestion={getSuggestionByFilter()} backgroundColor={isEmbeddedMode ? 'cloud.100' : 'darkMode.500'} color={isEmbeddedMode ? 'cloud.700' : 'cloud.500'} paddingX={6} paddingY={6} minHeight={isMobile ? '240px' : '360px'} data-sentry-element="CbEmptySearchState" data-sentry-component="GamesEmptyState" data-sentry-source-file="GamesEmptyState.tsx" />;
};